import { ReactNode } from 'react'

import { StaticImageData } from 'next/image'

import {
  WhyChooseEmajinGolf001Image,
  WhyChooseEmajinGolf002Image,
  WhyChooseEmajinGolfIcons001Image,
  WhyChooseEmajinGolfIcons002Image,
} from 'Assets/Images/Sections/WhyChooseEmajinGolfSection'

import { OFFER_URL } from 'Constants/Values'

export type WhyChooseEmajinGolPointItem = {
  id: string
  backgroundImage: StaticImageData
  backgroundImageAlt: string
  buttonCaption?: string
  iconImage: StaticImageData
  iconImageAlt: string
  link?: string
  plainText: ReactNode
}

export const WHY_CHOOSE_EMAJIN_GOL_POINT_ITEMS: WhyChooseEmajinGolPointItem[] =
  [
    {
      id: 'WhyChooseEmajinGolPointItem-001',
      plainText: (
        <>
          Whether you enjoy golf, or are more interested in business, learning
          and camaraderie; we offer something for everyone at each Emajin event.
          <br />
          <br />
          You’ll have the opportunity to play, build solid business
          relationships and enjoy stimulating talks at our events throughout the
          year.
        </>
      ),
      backgroundImage: WhyChooseEmajinGolf001Image,
      backgroundImageAlt: '',
      iconImage: WhyChooseEmajinGolfIcons001Image,
      iconImageAlt: '',
    },
    {
      id: 'WhyChooseEmajinGolPointItem-002',
      plainText: (
        <>
          The Power of Golf & Networking: Golf presents you with a valuable, and
          enjoyable way to grow your business. However, traditional
          opportunities to play are limited.
          <br />
          <br />
          Playing in the one-off corporate golf day is not the same as playing
          with a group of people who you get to know, like and trust over time.
          <br />
          <br />
          Emajin introduces a structured approach to business networking through
          golf, fostering lasting relationships on the greens.
        </>
      ),
      buttonCaption: 'Explore Our Membership',
      backgroundImage: WhyChooseEmajinGolf002Image,
      backgroundImageAlt: '',
      iconImage: WhyChooseEmajinGolfIcons002Image,
      iconImageAlt: '',
      link: OFFER_URL,
    },
  ]
